import { Record } from 'immutable';
const CustomerPortalSettingsRecord = Record({
  enabled: false
});
export default CustomerPortalSettingsRecord;